import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaDownload } from "react-icons/fa";
import "./About.css";
import calith from "./images/calith.jpg";
import thenic from "./images/cthenic.jpg";
import uzb from "./images/uzb.jpg";
import en from "./images/usa.jpg";
import es from "./images/spain.jpg";
import uae from "./images/uae.jpg";
import ru from "./images/rus.jpg";
import gif from "./images/giphy-3.mp4";
import { motion } from "framer-motion";

const About = () => {
  const [openMore, setOpenMore] = useState(false);

  return (
    <React.Fragment>
      <motion.div
        className="about"
        initial={{ opacity: 0, x: "-10vw" }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: "-30vw" }}
        transition={{ delay: 0.1, duration: 0.5 }}
      >
        <motion.div
          className="a-back"
          initial={{ scaleX: 0 }}
          animate={{ scaleX: 1 }}
          transition={{ delay: 0.2, duration: 1 }}
        ></motion.div>
        <motion.div
          className="a-nav"
          initial={{ opacity: 0, y: "-100%" }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4, duration: 1 }}
        >
          <a href="/resume.pdf" download className="cv">
            <span>Download CV</span>
            <FaDownload />
          </a>
          <nav>
            <Link className="a-home" to="/">
              Home
            </Link>
            <Link to="/contact">Contact</Link>
            <Link to="/projects">Projects</Link>
          </nav>
        </motion.div>
        {/* center */}
        <div className="a-center">
          <motion.div
            className="a-img"
            initial={{ x: "-30vw" }}
            animate={{ x: 0 }}
            transition={{ delay: 0.4, duration: 0.7 }}
          >
            <video src={gif} muted autoPlay loop />
          </motion.div>
          <motion.div
            className="a-txt"
            initial={{ opacity: 0, y: -30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6, duration: 1 }}
          >
            <h4>Web Developer</h4>
            <h2>Axel Reid</h2>
            <p>
              Just few words about me. I am Axel Reid from Uzbekistan and am a
              self-taught web developer since 2019. Currently, developing web
              with Html, Css and Js but favorably for most of the time, with the
              modern Javascript framework React, although i am still new in
              React. Probably, by the time you are reading this, i might already
              be better at that. Yeah, as a main career, i chose to be web
              developer, and again who knows, maybe i might explore something
              more to dream. <br />
              <span>
                If you want, explore some more about my interests and future
                goals.
              </span>
            </p>
            <a
              className="button"
              href="#moreAbout"
              onClick={() => setOpenMore(!openMore)}
            >
              {openMore ? "Collapse" : "Explore now"}
            </a>
          </motion.div>
        </div>
      </motion.div>

      {/* monre about */}
      {openMore ? (
        <div className="more-about" id="moreAbout">
          <h1 className="a-m-h2"></h1>
          {/* pentalingual */}
          <div className="a-center lingual">
            <div className="a-txt">
              <h4>Pentalingual</h4>
              <div className="lingua-img">
                <img src={uzb} />
                <img src={en} />
                <img src={es} />
                <img src={uae} />
                <img src={ru} />
              </div>
              <p>
                I have always been curious as to be able to talk in multiple
                languages, especially the ones shown on the picture those i have
                been trying to learn. My prior language is english which i were
                effected in the earlier school years and i am a fluent english
                speaker. It has been around 8 months learning spanish language.
                I do not yet know spanish that much, 'pero puedo hablar de
                espanol un poco'.
                <br /> As russian language is litirally considered as
                our(uzbeks) second mother tongue, i highly esteem its
                importance. I am a Muslim, Alhamdulilah, and for more Muslims
                especially ones whose language is not arabic definitely want to
                know it ( for specific reasons). So far, i learned to read and
                understand some of the basic sentences.
              </p>
            </div>
          </div>
          {/* calithenic */}
          <div className="a-center thenic">
            <div className="a-txt">
              <h4>Calithenic</h4>
              <div className="c-imgs">
                <img src={calith} />
                <img src={thenic} />
              </div>
              <p>
                I love Calithenics, it is bodyweight workout and that is much
                harder than other common exercices, even for some it is super
                tough. I spend few hours a day training this type. I can say it
                is a part of my life and is the way i care my wellbeing and
                physical, mental health, full body control and more... .
              </p>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </React.Fragment>
  );
};

export default About;
